<template>
  <div class="element-wrapper">
    <div class="content-box-no-heading" v-if="isLoadingReport || (loadingCompleted && report == null)">
      <div v-if="isLoadingReport" class="element-info-with-icon">
        <div class="element-info-icon">
          <div class="os-icon os-icon-grid-18 element-info-rotate"></div>
        </div>
        <div class="element-info-text">
          <h5 class="element-inner-header">
            {{ $t("report.loading_report") }}
          </h5>
          <div class="element-inner-desc">
            {{ $t("general.please_wait_data_from_cedoon") }}
          </div>
        </div>
      </div>

      <div v-else-if="loadingCompleted && report == null" class="element-info-with-icon">
        <div class="element-info-icon">
          <div class="os-icon os-icon-close"></div>
        </div>
        <div class="element-info-text">
          <h5 class="element-inner-header">
            {{ $t("report.error_loading_report") }}
          </h5>
          <div class="element-inner-desc">
            {{ $t("general.error.id_doesnt_exist") }}
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="report">
      <create-report :isConfiguring="true" :initial_report="report"></create-report>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ReportsCreate from "./reports.create.component";

export default {
  name: "ReportsEdit",
  data() {
    return {
      reportId: null,
      isLoadingReport: true,
      report: null,
      loadingCompleted: false
    };
  },
  components: {
    "create-report": ReportsCreate
  },
  mounted() {
    this.reportId = this.$route.params.id;

    this.isLoadingReport = true;

    this.detail(this.reportId)
      .then(response => {
        this.isLoadingReport = false;
        this.loadingCompleted = true;

        this.report = response.data.report;

        const sheetIds = this.sheetids && this.sheetids.split(",");

        if (sheetIds) {
          this.report.sheets = this.report.sheets.filter(sheet => sheetIds.includes(`${sheet.id}`));
        }

        this.report.sheets.forEach(sheet => {
          sheet.characteristics = [];

          sheet.characteristicGroups.forEach(group => {
            sheet.characteristics.push(...group.characteristics);
          });

          sheet.characteristics.sort((a, b) => a.sort - b.sort);
          sheet.characteristics.forEach(c => {
            c.measurements.sort((a, b) => a.measurements_id - b.measurements_id);
          });

          if (sheet.attachments) {
            sheet.attachments = Object.values(sheet.attachments);
          }

          sheet.columns = 10;

          const properties = {};
          sheet.product.properties.stringValue.forEach(prop => {
            properties[prop.propertyType] = prop;
          });
          sheet.product.properties.singleValue.forEach(prop => {
            properties[prop.propertyType] = prop;
          });
          sheet.product.properties.multpileValues.forEach(prop => {
            properties[prop.propertyType] = prop.values;
          });

          sheet.product.properties = properties;

          sheet.product.work_order_nr = sheet.work_order_nr;

          sheet.hasWoodInfo =
            sheet.info.woodNr ||
            sheet.info.woodMoisture ||
            sheet.info.roomTemperature ||
            sheet.info.insertionDirection ||
            sheet.info.woodDensity ||
            sheet.info.roomMoisture;
        });

        this.report.sheets.sort((a, b) => a.id - b.id);

        if (this.report.attachments) {
          this.report.attachments = Object.values(this.report.attachments);
        }

        if (this.report.sheets) {
          this.report.sheets.forEach(sheet => {
            sheet.hasMeasurements =
              sheet.characteristics.filter(
                c =>
                  c.measurements &&
                  c.measurements.length > 0 &&
                  c.measurements.filter(c1 => c1.value !== undefined && c1.value !== null).length > 0
              ).length > 0;
            sheet.articleNumber = sheet.product.properties.ARTICLE_NUMBER.value;
            sheet.product.templates = [sheet.template];
          });

          this.report.sheets.sort((a, b) => a.id - b.id);
        }

        console.log(this.report);
      })
      .catch(e => {
        console.log(e);
        this.isLoadingReport = false;
        this.loadingCompleted = true;
        this.report = null;
      });
  },
  methods: {
    ...mapActions("reportStore", ["detail"])
  }
};
</script>

<style scoped></style>
